/**
 * QuizService - Service pour la gestion des quiz "Les Petites Questions"
 */

class QuizService {
  static instance = null;
  
  constructor() {
    this.api = null;
  }
  
  static getInstance() {
    if (!QuizService.instance) {
      QuizService.instance = new QuizService();
    }
    return QuizService.instance;
  }
  
  setApi(api) {
    this.api = api;
  }
  
  /**
   * Récupère le nombre total de questions disponibles pour l'utilisateur
   */
  async getTotalAvailableCount() {
    try {
      const response = await this.api.get('/quiz/total-available');
      return response.data.total_available || 0;
    } catch (error) {
      console.error('Erreur récupération total quiz:', error);
      return 0;
    }
  }
  
  /**
   * Récupère le nombre de questions disponibles pour un enfant
   */
  async getAvailableCountForChild(childId) {
    try {
      const response = await this.api.get(`/quiz/available-count/${childId}`);
      return response.data.available_count || 0;
    } catch (error) {
      console.error('Erreur récupération count quiz enfant:', error);
      return 0;
    }
  }
  
  /**
   * Récupère les questions de quiz pour un enfant
   */
  async getQuestionsForChild(childId, limit = 10) {
    try {
      const response = await this.api.get(`/quiz/questions/${childId}`, {
        params: { limit }
      });
      return response.data.questions || [];
    } catch (error) {
      console.error('Erreur récupération questions quiz:', error);
      return [];
    }
  }
  
  /**
   * Récupère les questions de quiz pour une conversation spécifique
   */
  async getQuestionsForConversation(conversationId) {
    try {
      const response = await this.api.get(`/quiz/conversation/${conversationId}`);
      return response.data.questions || [];
    } catch (error) {
      console.error('Erreur récupération questions conversation:', error);
      return [];
    }
  }
  
  /**
   * Soumet une réponse à un quiz
   */
  async submitAnswer(quizId, isCorrect, attempts = 1) {
    try {
      const response = await this.api.post(`/quiz/answer/${quizId}`, {
        is_correct: isCorrect,
        attempts: attempts
      });
      return response.data;
    } catch (error) {
      console.error('Erreur soumission réponse quiz:', error);
      throw error;
    }
  }
  
  /**
   * Récupère les questions archivées (maîtrisées) d'un enfant
   */
  async getArchivedQuestions(childId, limit = 50) {
    try {
      const response = await this.api.get(`/quiz/archived/${childId}`, {
        params: { limit }
      });
      return response.data.questions || [];
    } catch (error) {
      console.error('Erreur récupération questions archivées:', error);
      return [];
    }
  }
}

export default QuizService;
